export default (state, getters, rootState) => (code) => {
    let ag = getters.item(code);
    if (!ag) return;
    return ag.legals.filter(i => {
        return i.type === rootState.finances.pay.form.ContragentType && i.contragent === rootState.finances.pay.form.ContragentID;
    });
}